// extracted by mini-css-extract-plugin
export var borderTop = "_f-3";
export var linkIcon = "_f-5";
export var linkIconSm = "_f-6";
export var linkOutCard = "_f-7 _f-4";
export var linkRow = "_f-2";
export var pageContainer = "_f-1";
export var providerIcon = "_f-8";
export var roundedBorder = "_f-4";
export var settingsContent = "_f-0";